import { useMemo } from 'react'

interface PromoResult {
  isPromo: boolean
  promoEnd?: Date
  basePrice?: number
  promoPrice?: number
}

export const usePromo = (): PromoResult => {
  return useMemo(() => {
    if (process.env.REACT_APP_PROMO_ENABLED !== 'true') return { isPromo: false }

    const now = new Date()

    // 30 ноября — конец акции
    const promoEnd = new Date(now.getFullYear(), 10, 30, 23, 59, 59)

    if (now > promoEnd) return { isPromo: false }

    // Если до конца акции ≤ 15 дней — продлеваем на месяц
    const daysLeft = Math.ceil((promoEnd.getTime() - now.getTime()) / 86400000)
    const effectiveEnd =
      daysLeft <= 15
        ? new Date(promoEnd.getFullYear(), promoEnd.getMonth() + 1, 30, 23, 59, 59)
        : promoEnd

    return {
      isPromo: true,
      promoEnd: effectiveEnd,
      basePrice: 10000,
      promoPrice: 5000,
    }
  }, [])
}

export const formatPromoMonth = (date: Date): string => {
  const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ]
  return months[date.getMonth()]
}
